export const LayoutMain = ({ children }) => (
  <main>
    <div className="container mainContainer">{children}</div>
  </main>
);
